"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = function _default(period) {
  switch (period) {
    case 'week':
      return 'week.';
    case 'month':
      return 'month.';
    case '3months':
      return '3 months.';
    case '6months':
      return '6 months.';
    case 'year':
      return 'year.';
    default:
      return '';
  }
};
exports.default = _default;